import type { FC } from "react";
import {
  Flex,
  Section,
  Button,
  Icon,
} from "@/ui";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import type {
  TCatLifestyleCardHealthSectionProps,
} from "./CatLifestyleCard.config";

export const CatLifestyleCardHealthSection: FC<TCatLifestyleCardHealthSectionProps> = ({
  healthStats,
  title,
  editCopy,
  editAriaLabel,
  onEdit,
}) => (
  <Section>
    <Flex gap="4" align="center" justify="between">
      <TextSubtitle size={2} isResponsive={false}>
        { title }
      </TextSubtitle>
      <Button aria-label={editAriaLabel} onClick={onEdit} variant="tertiary">
        { editCopy }
      </Button>
    </Flex>

    <Flex align="start" className="mt-4" gap="3">
      { healthStats.map(({ icon, label, value }) => (
        <Flex
          key={label}
          align="center"
          className="flex-1"
          direction="column"
        >
          <Flex
            align="center"
            className="size-13 rounded-full bg-sys-chartreuse-25"
            justify="center"
          >
            <Icon aria-hidden="true" icon={icon} />
          </Flex>
          <TextBody className="mt-2" color="secondary" size={3} isResponsive={false}>
            { label }
          </TextBody>
          <TextSubtitle className="mt-1 break-words text-center" size={4} isResponsive={false}>
            { value }
          </TextSubtitle>
        </Flex>
      )) }
    </Flex>
  </Section>
);
